import React from 'react'

const Context = React.createContext({})

export const Provider = Context.Provider
export const Consumer = Context.Consumer
export default Context



// WEBPACK FOOTER //
// ./src/context/userContext.js